export default __webpack_public_path__ + "static/media/inovationMapIconON.2302a964.png";